import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

export const arbitrationsSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitrationList']);
export const getArbitrationNotesState = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'notes', 'state']);
export const arbitrationNotesSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'notes', 'data']).toJS();
export const arbitrationSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitration']).toJS().data;
export const arbitrationSelectorState = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitration']).toJS().state;
export const arbitrationHeadersSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitrationHeaders']).toJS()
    .data;
export const arbitrationHeadersSelectorState = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitrationHeaders']).toJS()
    .state;
export const arbitrationHeadersPropertiesSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrationProperties', 'data']).toJS();
/* const properties =
    arbitrationHeaders && arbitrationHeaders.getIn(['data', 'properties'])
      ? arbitrationHeaders.getIn(['data', 'properties']).toJS()
      : []; */
export const arbitrationStatusSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitrationStatus']).toJS()
    .data;
export const arbitrationStatusSelectorState = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'arbitrationStatus']).toJS()
    .state;
export const notesSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'notes']);
export const arbitrationDetailFormSelector = state =>
  state.getIn(['form', 'litigationArbitrationDetail']);
export const getSearchArbitrations = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'searchArbitrations']);
export const newArbitrationSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'newArbitration']);

export const dropdownsSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'dropdowns', 'data'], Map({}))
    .toJS();
export const dropdownsSelectorState = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'dropdowns']).toJS().state;

export const arbitrationStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration']).toJS().state;
export const activeArbitrationSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'activeArbitration']); //.toJS().activearbitration;

export const getArbitrationSelectorData = createSelector(
  [arbitrationSelector],
  arbitrationIm =>
    arbitrationIm.get('data') ? arbitrationIm.get('data').toJS() : null,
);

export const arbitrationPresentationSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'arbitrationPresentation', 'data'],
      List([]),
    )
    .toJS();
export const arbitrationpresentationDocumentsSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'presentationDocuments', 'data'],
      List([]),
    )
    .toJS();

export const arbitrationCasePrepSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'casePrep', 'data'], Map({}))
    .toJS();

export const arbitrationEventsSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'events']);

export const arbitrationHearingSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'hearing', 'data'], Map({}))
    .toJS();

export const arbitrationHearingStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'hearing']).toJS().state;

export const arbitrationDispositionSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'disposition', 'data'], Map({}))
    .toJS();

export const arbitrationDispositionStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'disposition']).toJS().state;

export const arbitrationAvailableAgentsSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'availableAgents', 'data'],
      List([]),
    )
    .toJS();

export const arbitrationAvailableAgentsStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'availableAgents']).toJS()
    .state;

export const arbitrationAvailableOwnersSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'availableOwners', 'data'],
      List([]),
    )
    .toJS();

export const arbitrationAvailableOwnersStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'availableOwners']).toJS()
    .state;

export const arbitrationProposedRollCorrectionsSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'proposedRollCorrections', 'data'],
      List([]),
    )
    .toJS();

export const arbitrationProposedRollCorrectionsStateSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'proposedRollCorrections'])
    .toJS().state;

export const arbitrationIncomeActualStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'incomeActual', 'state']);

export const arbitrationIncomeModelStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitration', 'incomeModel', 'state']);

export const arbitrationIncomeActualSelector = state =>
  state
    .getIn(
      ['app', 'litigation', 'arbitration', 'incomeActual', 'data'],
      Map({}),
    )
    .toJS();

export const arbitrationIncomeModelSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitration', 'incomeModel', 'data'], Map({}))
    .toJS();
